import { TestableWord } from "../../../wordfill/types";
import { Answer, Content, Step } from "../../types";

export function getCurrentUserInput(
  userAnswer: Answer,
  stepIndex: number,
  wordId: string
) {
  return userAnswer.steps[stepIndex][wordId];
}

export function calculateTotalScore(content: Content) {
  const { steps } = content;
  let totalPossibleScore = 0;
  steps.forEach(step => {
    step.equation.forEach(word => {
      if (typeof word !== "string" && word.testing) totalPossibleScore++;
    });
  });
  return totalPossibleScore;
}

export function stepIsNotTested(step: Step) {
  const { equation } = step;
  return equation.every(word => !wordIsTested(word));
}

export function stepIsTested(step: Step) {
  return !stepIsNotTested(step);
}

export function wordIsTested(word: string | TestableWord): boolean {
  return typeof word !== "string" && Boolean(word.testing);
}

export function getTotalNumberOfTestableWords(steps: Step[]) {
  return steps.reduce(
    (total, { equation }) => total + equation.filter(wordIsTested).length,
    0
  );
}
